export default (that) => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'defaultImageUrl',
    width: 80,
    title: that.$l('INDEX.table_label_image') || '图片',
    headerAlign: 'left',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' }
  },
  {
    title: that.$l('INDEX.table_label_goodsName') || '产品名称',
    field: 'goodsName',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayName' }
  },
  {
    title: that.$l('table_label_brand_name') || '品牌名称',
    field: 'brandName',
    minWidth: 160,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayBrand' }
  },

  {
    title: that.$l('INDEX.table_label_factory') || '成品工厂',
    field: 'scmName',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayFactory' }
  },
  {
    title: that.$l('table_label_location_no') || '库位编号',
    field: 'locationNo',
    minWidth: 160,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_in_ctnQty') || '装箱入数',
    field: 'inCtnQty',
    minWidth: 80,
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_ctn_qty') || '箱数',
    field: 'ctnQty',
    minWidth: 80,
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_goods_qty') || '产品数',
    field: 'goodsQty',
    minWidth: 80,
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_fty_price') || '采购单价',
    field: 'ftyPrice',
    minWidth: 100,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_sub_amount') || '成本金额',
    field: 'subAmount',
    minWidth: 100,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) =>
      !cellValue ? cellValue : cellValue.toLocaleString(undefined, { minimumFractionDigits: 2 }),
  },
]
